import {
	ValidatorConstraint,
	ValidatorConstraintInterface,
	ValidationArguments,
	registerDecorator,
	ValidationOptions
} from 'class-validator';
import { CreativeUnitDto } from '../models/creative-unit/creative-unit.dto';

@ValidatorConstraint({ name: 'exportCropBoxBounds', async: false })
export class ExportCropBoxBoundsConstraint implements ValidatorConstraintInterface {
	validate(exportCropBox: any, args: ValidationArguments) {
		const creativeUnit = args.object as CreativeUnitDto;
		
		// If crop box is not enabled or not provided, it's valid
		if (!exportCropBox || !exportCropBox.enabled) {
			return true;
		}

		// Check if dimensions exist
		if (!creativeUnit.dimensions) {
			return false;
		}

		const { x, y, width, height } = exportCropBox;
		const unitWidth = creativeUnit.dimensions.width;
		const unitHeight = creativeUnit.dimensions.height;

		// Validate crop box boundaries
		return (
			x >= 0 &&
			y >= 0 &&
			width > 0 &&
			height > 0 &&
			(x + width) <= unitWidth &&
			(y + height) <= unitHeight
		);
	}

	defaultMessage(args: ValidationArguments) {
		const creativeUnit = args.object as CreativeUnitDto;
		const unitWidth = creativeUnit.dimensions?.width || 'unknown';
		const unitHeight = creativeUnit.dimensions?.height || 'unknown';
		
		return `Export crop box must be within creative unit boundaries (${unitWidth}x${unitHeight}). ` +
			   `Ensure x + width <= ${unitWidth} and y + height <= ${unitHeight}.`;
	}
}

export function IsValidExportCropBox(validationOptions?: ValidationOptions) {
	return function (object: Object, propertyName: string) {
		registerDecorator({
			target: object.constructor,
			propertyName: propertyName,
			options: validationOptions,
			constraints: [],
			validator: ExportCropBoxBoundsConstraint
		});
	};
}